import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LoginLibService } from '@ebootis/login';
import { isOnline } from '../services/Ebootis.Queries/isOnline';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {

  constructor(
    private m_router: Router,
    private m_loginLibService: LoginLibService,
    private m_query: isOnline,
  ) { }

  canActivate(p_route: ActivatedRouteSnapshot, p_state: RouterStateSnapshot): boolean {
    if (this.m_loginLibService.LoggedIn) {
      return true;
    } else {
      this.m_router.navigate(['anmelden']);
      return false;
    }
  }
}
